import { useState } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableContainer,
} from "@material-ui/core";
import { dateTypeFormatter } from "../../components/data-formatter/date-type.formatter";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
  options: {
    width: "120px!important",
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    // height: '25px!important',
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  mui1: {
    border: "1px!important",
    color: "red!important",
    // height: '25px!important',
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
    paddingLeft: "20px!important",
  },
}));
const UserblockListResults = ({ customers, ...rest }) => {
  // const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const classes = useStyles();
  /* eslint no-underscore-dangle: ["error", { "allow": ["_export"] }] */

  const handleLimitChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  return (
    // <Box sx={{ pt: 3 }}>

    // </Box>

    <Box sx={{ minWidth: 1050 }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Wallet ADD</TableCell>
                <TableCell>Blocked Time</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell>More</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer) => (
                  <TableRow
                    hover
                    key={customer.id}
                    // selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                  >
                    <TableCell>{customer.address}</TableCell>
                    <TableCell>
                      {dateTypeFormatter(customer.blocked_at)}
                    </TableCell>
                    <TableCell>
                      {customer?.status === 0 ? "Active" : "Blocked"}
                    </TableCell>
                    <TableCell>
                      <a href={`/app/dashboard?id=${customer.address}`}>More</a>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* </ExcelExport> */}

        <TablePagination
          component="div"
          count={customers.length}
          onChangePage={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5]}
        />
      </Paper>
    </Box>
  );
};

UserblockListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default UserblockListResults;
